/**
 * Created by zhijie.huang on 2017/5/18.
 */

import TimeFormat from '@/utils/timeFormat'

const SIZE_DATA_PARSE = 1024

export default class ChartHelper {
    // format:'PERCENT'
    // xdesc:'时间'
    // xname:'revtime'
    // xtype:'LONG'
    // ydesc:'磁盘IO使用率'
    // yname:'IORate'
    // ytype:'LONG'

    // appName:'hostperf'
    // desc:'磁盘IO使用率'
    // group:'system'
    // id:'59199178fcdf150f90c0c3f2'
    // kpiKey:'IORate'

    fieldData = null;

    static getUnit (unit, data) {
      const unitArr = ['BYTE', 'KB', 'MB', 'GB']
      const newUnit = unitArr.indexOf(unit) !== -1 ? unit : unitArr[0]

      if (newUnit === 'GB') {
        return {
          unit: newUnit,
          data: data
        }
      } else if (data > SIZE_DATA_PARSE) {
        const index = unitArr.indexOf(newUnit) + 1
        data = parseInt(data / SIZE_DATA_PARSE)
        return ChartHelper.getUnit(unitArr[index], data)
      } else {
        return {
          unit: newUnit,
          data: data
        }
      }
    }

    static convertDataWithUnit (unit, newUnit, data) {
      unit = unit || 'BYTE'
      if (unit !== newUnit) {
        const unitArr = ['BYTE', 'KB', 'MB', 'GB']
        const carry = unitArr.indexOf(newUnit) - unitArr.indexOf(unit)
        data = (data / Math.pow(SIZE_DATA_PARSE, carry)).toFixed(2)
      }
      return data
    }

    constructor (fieldData) {
      if (fieldData) {
        this.fieldData = fieldData
      }
    }

    /**
     * 常用图表表头信息转换方法
     * @param data （Object 接口数据）
     */
    convertFieldsData (data) {
      if (this.fieldData === null) {
        this.fieldData = []
      }
      if (data instanceof Array) {
        data.map((item, index, array) => {
          const id = item.appName + '_' + item.kpiKey
          const res = {
            id: id,
            group: item.group,
            appName: item.appName,
            kpiKey: item.kpiKey,
            desc: item.desc,
            fields: item.fields,
            threshold: item.threshold
          }
          this.fieldData.push(res)
        })
        // dashBoard
      } else {
        const res = {
          id: data.id,
          group: data.group,
          appName: data.appName,
          kpiKey: data.kpiKey,
          desc: data.desc,
          fields: data.fields,
          threshold: data.threshold
        }
        this.fieldData.push(res)
      }
    }

    /**
     * 常用图表数据转换方法
     * @param field（Object 表头数据）
     * @param data（Object 接口数据）
     * @returns {{dataX: Array, dataY: Array}}
     */
    converChartData (field, data) {
      const dataY = []
      const dataX = []
      const kpi = data.performs ? data.performs : data
      const threshold = []
      let maxValue = 0
      let sizeUnit = ''
      const legend = []
      let eachThreshold = null
      if (field.threshold !== 0) {
        eachThreshold = field.threshold
      }

      field.fields.map(function (item) {
        dataY.push({
          format: item.format,
          unit: item.unit,
          data: [],
          name: item.yDesc
        })
        legend.push(item.yDesc)
      })

      if (kpi && kpi.length > 0) {
        for (let j = 0; j < kpi.length; j++) {
          let x
          // 有多个fields
          field.fields.map(function (item, index) {
            x = kpi[j][item.xName]
            // 判断是否是主机图表的数据格式
            if (kpi[j].hasOwnProperty(item.yName)) {
              dataY[index].data.push(kpi[j][item.yName])
            } else {
              dataY[index].data.push(kpi[j].value)
            }
            // 如果是百分比的格式 数据乘以100
            if (item.format === 'PERCENT') {
              dataY[index].data[j] = (Number(dataY[index].data[j]) * 100).toFixed(2)
            } else if (item.format === 'SIZE') {
              if (Number(dataY[index].data[j]) > maxValue) {
                maxValue = Number(dataY[index].data[j])
              }
            }
            threshold.push(eachThreshold)
          })
          if (String(x).length === 10) {
            x = x * 1000
          }
          x = TimeFormat.formatDateTime('MM-dd HH:mm', x)
          dataX.push(x)
        }
      }

      for (let i = 0; i < dataY.length; i++) {
        const unit = dataY[0].unit
        const newUnit = ChartHelper.getUnit(dataY[0].unit, maxValue).unit
        sizeUnit = newUnit

        for (let j = 0; j < dataY[i].data.length; j++) {
          dataY[i].data[j] = ChartHelper.convertDataWithUnit(unit, newUnit, dataY[i].data[j])
        }
      }

      return {
        dataX: dataX,
        dataY: dataY,
        sizeUnit: sizeUnit,
        threshold: threshold,
        legend: legend,
        maxValue: maxValue
      }
    }

    converLogChartData (data) {
      const dataY = []
      const dataX = []
      const xName = 'LOGUCL_EVENTTIME'
      const kpiKeyList = [
        'kpiCount',
        'eventCount',
        'errorCount',
        'uploadCount',
        'infoCount'
      ]
      kpiKeyList.map(function (item) {
        dataY.push({
          format: '',
          data: [],
          name: item
        })
      })

      if (data && data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let x = data[j][xName]
          x = TimeFormat.getFormatTime(x)
          for (let i = 0; i < kpiKeyList.length; i++) {
            dataY[i].data.push(data[j][kpiKeyList[i]])
          }
          dataX.push(x)
        }
      }

      return {
        dataX: dataX,
        dataY: dataY,
        legend: kpiKeyList
      }
    }

    converLogAreaChartData (data) {
      const dataY = []
      const dataX = []
      const xName = 'LOGUCL_EVENTTIME'
      const kpiKeyList = [
        'kpiCount',
        'eventCount',
        'errorCount',
        'infoCount',
        'uploadCount'
      ]
      kpiKeyList.map(function (item) {
        dataY.push({
          name: item,
          type: 'line',
          stack: '1',
          itemStyle: {
            normal: {}
          },
          areaStyle: {
            normal: {}
          },
          lineStyle: {
            normal: {}
          },
          data: [],
          symbol: 'none',
          smooth: true
        })
      })

      if (data && data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let x = data[j][xName]
          x = TimeFormat.formatDateTime('MM-dd HH:mm', x)// timeFormat.getFormatTime(x);
          for (let i = 0; i < kpiKeyList.length; i++) {
            dataY[i].data.push(data[j][kpiKeyList[i]])
          }
          dataX.push(x)
        }
      }

      return {
        dataX: dataX,
        dataY: dataY,
        legend: kpiKeyList
      }
    }

    converWorkingQualityChartData (data, isMore, converLan) {
      const dataY = [],
        dataX = []

      const chartLegend = ['regularCount', 'patchCount']

      if (isMore) {
        chartLegend.map(function (item) {
          if (converLan) {
            if (item === 'regularCount') {
              item = converLan.regular
            } else if (item === 'patchCount') {
              item = converLan.patch
            }
          }
          dataY.push({
            name: item,
            type: 'line',
            stack: item,
            areaStyle: {
              normal: {}
            },
            data: [],
            symbolSize: 8,
            smooth: true
          })
        })

        if (data && data.length > 0) {
          for (let j = 0; j < data.length; j++) {
            let x = data[j].time
            x = TimeFormat.getFormatTime(x)
            for (let i = 0; i < chartLegend.length; i++) {
              dataY[i].data.push(data[j][chartLegend[i]])
            }
            dataX.push(x)
          }
        }

        if (converLan) {
          for (let i = 0; i < chartLegend.length; i++) {
            if (chartLegend[i] === 'regularCount') {
              chartLegend[i] = converLan.regular
            } else if (chartLegend[i] === 'patchCount') {
              chartLegend[i] = converLan.patch
            }
          }
        }
      } else {
        if (data && data.length > 0) {
          dataY.push({
            name: '',
            type: 'line',
            areaStyle: {
              normal: {}
            },
            data: [],
            symbolSize: 8,
            smooth: true
          })
          for (let j = 0; j < data.length; j++) {
            let x = data[j].time
            x = TimeFormat.getFormatTime(x)
            dataX.push(x)
            dataY[0].data.push(data[j].count)
          }
        }
      }
      const res = {
        dataX: dataX,
        dataY: dataY
      }
      if (isMore) {
        res.legend = chartLegend
      }
      return res
    }

    converITDevChartData (data, converLan) {
      const chartLegend = ['hwMemoryDevRawSliceUsed', 'hwMemoryDevSize']
      const dataY1 = []
      const dataY2 = []
      const dataX = []

      chartLegend.map(function (item) {
        if (item === 'hwMemoryDevRawSliceUsed') {
          item = converLan.cpuUsed
        }
        if (item === 'hwMemoryDevSize') {
          item = converLan.cpuSize
        }
        dataY1.push({
          data: [],
          name: item
        })
        dataY2.push({
          data: []
        })
      })

      if (data && data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let x = data[j].createTime
          x = TimeFormat.getFormatTime(x)
          for (let i = 0; i < chartLegend.length; i++) {
            dataY1[i].data.push(data[j][chartLegend[i]])
          }
          dataY2[0].data.push(data[j].hwCpuDevDuty)
          dataX.push(x)
        }
      }

      if (converLan) {
        for (let i = 0; i < chartLegend.length; i++) {
          if (chartLegend[i] === 'hwMemoryDevRawSliceUsed') {
            chartLegend[i] = converLan.cpuUsed
          }
          if (chartLegend[i] === 'hwMemoryDevSize') {
            chartLegend[i] = converLan.cpuSize
          }
        }
      }

      return {
        0: {
          dataX: dataX,
          dataY: dataY2
        },
        1: {
          dataX: dataX,
          dataY: dataY1,
          legend: chartLegend
        }
      }
    }

    converITPortChartData (fields, data, converLan) {
      const dataY = []
      const dataX = []
      const xName = 'createTime'
      const kpiKeyList = [
        'inletFlow',
        'outletFlow'
      ]
      let maxValue = 0
      let sizeUnit = ''
      kpiKeyList.map(function (item) {
        if (item === 'inletFlow') {
          item = converLan.inletFlow
        } else if (item === 'outletFlow') {
          item = converLan.outletFlow
        }
        dataY.push({
          name: item,
          type: 'line',
          format: fields.format,
          unit: fields.unit,
          stack: item,
          areaStyle: {
            normal: {}
          },
          data: [],
          symbol: 'none',
          smooth: true
        })
      })

      if (data && data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let x = data[j][xName]
          x = TimeFormat.getFormatTime(x)
          for (let i = 0; i < kpiKeyList.length; i++) {
            dataY[i].data.push((data[j][kpiKeyList[i]]).toFixed(2))
            // 如果是百分比的格式 数据乘以100
            if (fields.format === 'PERCENT') {
              dataY[i].data[j] *= 100
            } else if (fields.format === 'SIZE') {
              if (Number(dataY[i].data[j]) > maxValue) {
                maxValue = Number(dataY[i].data[j])
              }
            }
          }
          dataX.push(x)
        }
      }

      for (let i = 0; i < dataY.length; i++) {
        const unit = dataY[0].unit
        const newUnit = ChartHelper.getUnit(unit, maxValue).unit
        sizeUnit = newUnit

        for (let j = 0; j < dataY[i].data.length; j++) {
          dataY[i].data[j] = ChartHelper.convertDataWithUnit(unit, newUnit, dataY[i].data[j])
        }
      }

      for (let i = 0; i < kpiKeyList.length; i++) {
        if (kpiKeyList[i] === 'inletFlow') {
          kpiKeyList[i] = converLan.inletFlow
          dataY[i].maxValue = maxValue
          dataY[i].sizeUnit = sizeUnit
        } else if (kpiKeyList[i] === 'outletFlow') {
          kpiKeyList[i] = converLan.outletFlow
          dataY[i].maxValue = maxValue
          dataY[i].sizeUnit = sizeUnit
        }
      }

      return {
        dataX: dataX,
        dataY: dataY,
        legend: kpiKeyList
      }
    }

    converUserTrendlData (data) {
      const [line1, line2] = [[], []]
      if (data.hasOwnProperty('history')) {
        data.history.map((item, index) => {
          let x = item.time
          const valueArr = [x, item.count]
          line1.push({ value: valueArr })
        })
      } else {
        data.today.map((item, index) => {
          let x = item.time
          const valueArr = [x, item.count]
          line1.push({ value: valueArr })
        })
        data.yestoday.map((item, index) => {
          let x = item.time
          const valueArr = [x, item.count]
          line2.push({ value: valueArr })
        })
      }
      return {
        line1: line1,
        line2: line2
      }
    }

    converUserTrendkData (data) {
      const [datatime, datak, today] = [[], [], []]
      if (data.hasOwnProperty('history')) {
        data.history.map((item, index) => {
          // if (index === 0 || index % 5 === 0) {
          let x = item.time
          x = TimeFormat.formatDateTime('yyyy-MM-dd HH:mm', x)
          datatime.push(x)
          today.push(item.count)
        })
      } else {
        data.today.map((item, index) => {
          // if (index === 0 || index % 5 === 0) {
          let x = item.time
          x = TimeFormat.formatDateTime('yyyy-MM-dd HH:mm', x)
          datatime.push(x)
          today.push(item.count)
        })
      }
      today.map((item, index) => {
        if (today[index] > today[index + 1]) {
          datak.push([today[index], today[index + 1], today[index + 1], today[index]])
        } else {
          datak.push([today[index], today[index + 1], today[index], today[index + 1]])
        }
      })
      return {
        datatime: datatime,
        datak: datak,
        today: today
      }
    }

    converUserDistribution (data) {
      const [Allcount, country, countryCount] = [[], [], []]
      data.tmlCountryList.map((item, index) => {
        country.push(item.iso)
        countryCount.push(item.count)
      })
      Allcount.push(data.userCount)
      Allcount.push(data.tmlCountryCount)
      Allcount.push(data.userMax)
      Allcount.push(data.hisOnlineCountryMax)
      Allcount.push(data.todayOnlineTmlMax)
      Allcount.push(data.todayLoginTmlCount)
      return {
        Allcount: Allcount,
        country: country,
        countryCount: countryCount
      }
    }

    converInterfaceChartData (data) {
      const [dataX, dataY] = [[], [{
        name: '',
        type: 'line',
        stack: '',
        areaStyle: {
          normal: {}
        },
        data: [],
        symbolSize: 8,
        smooth: true
      }]]

      data.map((item) => {
        let x = item.eventTime
        x = TimeFormat.getFormatTime(x)
        dataX.push(x)
        dataY[0].data.push(item.avg)
      })

      return {
        dataX: dataX,
        dataY: dataY
      }
    }
}
